import { styled } from '@mui/material/styles';
import { Modal, ModalHeader } from 'core/common/ui/ui-kit';

export const ModalStyled = styled(Modal)`
  display: ${({ open }) => (open ? 'block' : 'none')};

  & .MuiPaper-root {
    margin: 16px;
    padding: 20px 16px 16px;
    border-radius: 20px;
    overflow: hidden;
    background: ${({ theme }) => theme.palette.payment.background};
  }

  * {
    color: ${({ theme }) => theme.palette.payment.primaryText};
  }
`;

export const ModalHeaderStyled = styled(ModalHeader)`
  & .MuiIconButton-root {
    align-self: flex-start;
  }

  & svg {
    width: 24px;
    height: 24px;
  }
`;

export const ScrollAreaStyled = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  overflow: hidden auto;
`;
